export default "__VITE_ASSET__CK98RuBR__"